/* OPQ Board — clean white homepage. Currently just a background colour
   picker; the discussion / note board feature lands here later. */

const STORAGE_KEY_BG = 'opq-board-bg';

function initBoard(root) {
  const bgBtn    = root.querySelector('[data-opq-board-bg-btn]');
  const bgIn     = root.querySelector('[data-opq-board-bg-input]');
  const bgSwatch = root.querySelector('[data-opq-board-bg-swatch]');
  if (!bgBtn || !bgIn) return;

  const apply = (color) => {
    if (!color) return;
    document.documentElement.style.setProperty('--opq-board-bg', color);
    bgIn.value = color;
    if (bgSwatch) bgSwatch.style.background = color;
  };

  apply(localStorage.getItem(STORAGE_KEY_BG) || '#ffffff');

  /* Input is now full-size inside the dock button with pointer-events: auto,
     so user taps land directly on the colour input. If the button itself
     somehow gets a click (e.g. keyboard focus + Enter), forward to the input. */
  bgBtn.addEventListener('click', (e) => {
    if (e.target === bgIn) return;
    bgIn.click();
  });
  bgIn.addEventListener('input', (e) => {
    apply(e.target.value);
    try { localStorage.setItem(STORAGE_KEY_BG, e.target.value); } catch {}
  });
}

document.querySelectorAll('[data-opq-board]').forEach(initBoard);
